export const institutos = {
  'undefined': '',
  '0': 'Itbm',
  '1': 'Mexico ',
  '2': 'Central America and the Caribbean',
  '3': 'China and Greater China',
  '4': 'Singapore',
  '5': 'Turkey',
  '6': 'Philippines',
  '7': 'Ecuador',
  '8': 'izzi',
  '9': 'Romania',
  '11': 'Brazil',
  '12': 'Chile',
  '13': 'Argentina',
  '14': 'Broker 14',
  '15': 'Spain',
  '16': 'Itbm',
  '17': 'One Survey',
  '18': 'Amco',
  '19': 'InnMotion',
  '22': 'China and Hong Kong 2'
}


export const sectores = {
  "1":{
     "NOMBRE":"2.0 Aerospace",
     "SUBSECTORES":{
        "1":"2.1 Aerospace // Other / Does not apply"
     }
  },
  "2":{
     "NOMBRE":"4.0 Agriculture",
     "SUBSECTORES":{
        "1":"4.1 Agriculture // Other / Does not apply "
     }
  },
  "3":{
     "NOMBRE":"5.0 Biotechnology and Pharmaceuticals",
     "SUBSECTORES":{
        "1":"5.1 Biotechnology and Pharmaceutical // Biotechnology",
        "2":"5.2 Biotechnology and Pharmaceutical // Pharmaceutical",
        "3":"5.3 Biotechnology and Pharmaceutical // Other"
     }
  },
  "4":{
     "NOMBRE":"6.0 Construction",
     "SUBSECTORES":{
        "1":"(OLD) Construction // Contracting",
        "2":"(OLD) Construction // Infrastructure",
        "3":"6.1 Construction // Other / Does not apply"
     }
  },
  "5":{
     "NOMBRE":"12.0 Health Care",
     "SUBSECTORES":{
        "1":"(OLD) Health Care // Residential Care Services",
        "2":"12.1 Health Care // Hospital",
        "3":"12.2 Health Care // Sale or Distribution of Medical Supplies",
        "4":"12.3 Health Care // Specialty",
        "5":"(OLD) Aging Services // Home Care",
        "6":"(OLD) Aging services // Housing and care for the elderly",
        "7":"(OLD) Medical care // Other specialized services",
        "8":"12.4 Health Care // Services",
        "9":"12.5 Health Care // Other",
     }
  },
  "6":{
     "NOMBRE":"7.0 Education and training",
     "SUBSECTORES":{
        "1":"7.1 Education and training // Other / Does not apply"
     }
  },
  "7":{
     "NOMBRE":"13.0 Hospitality",
     "SUBSECTORES":{
        "3":"13.1 Hospitality // Food and beverage service",
        "2":"13.2 Hospitality // Hotel / Resort",
        "1":"13.3 Hospitality // Administration",
        "4":"13.4 Hospitality // Other"
     }
  },
  "8":{
     "NOMBRE":"16.0 Manufacturing and Production",
     "SUBSECTORES":{
        "28":"16.1 Manufacturing and Production // Alternative Energy",
        "1":"16.2 Manufacturing and Production // Automotive",
        "15":"16.3 Manufacturing and Production // Basic Metals and Metal Products",
        "14":"16.4 Manufacturing and Production // Construction Materials",
        "24":"16.5 Manufacturing and Production // Chemicals",
        "3":"16.6 Manufacturing and Production // Coke, petroleum derivatives and nuclear fuel",
        "8":"16.7 Manufacturing and Production // Electrical, electronic and optical equipment",
        "6":"16.8 Manufacturing and Production // Electronics",
        "7":"16.9 Manufacturing and Production // Energy",
        "5":"16.10 Manufacturing and Production // Energy Distribution",
        "20":"16.11 Manufacturing and Production // Food Products: Dairy and poultry products",
        "21":"16.12 Manufacturing and Production // Food Products: Tobacco",
        "19":"16.13 Manufacturing and Production // Food Products: Beverages",
        "18":"16.14 Manufacturing and Production // Food Products: Others",
        "16":"16.15 Manufacturing and Production // Furniture",
        "10":"16.16 Manufacturing and Production // Gasoline / Retail",
        "31":"16.17 Manufacturing and Production // Health Care",
        "17":"16.18 Manufacturing and Production // Leather and leather products",
        "13":"16.19 Manufacturing and Production // Machinery and equipment",
        "11":"16.20 Manufacturing and Production // Medical Devices",
        "22":"16.21 Manufacturing and Production // Non-metallic minerals",
        "2":"16.22 Manufacturing and Production // Products for personal and home care",
        "23":"16.23 Manufacturing and Production // Pulp, paper and paper derivatives",
        "4":"16.24 Manufacturing and Production // Rubber and plastic products",
        "25":"16.25 Manufacturing and Production // Safety",
        "26":"16.26 Manufacturing and Production // Textiles and textile products",
        "30":"16.27 Manufacturing and Production // Transportation equipment",
        "29":"16.28 Manufacturing and Production // Water supply and treatment",
        "12":"16.29 Manufacturing and Production // Wood and wood derivatives",
        "32":"16.30 Manufacturing and Production // Other",
        "27":"(OLD) Manufacturing and Production // Fast-moving consumer goods",
        "9":"(OLD) Manufacturing and Production // Healthcare",
     }
  },
  "9":{
     "NOMBRE":"17.0 Media",
     "SUBSECTORES":{
        "1":"17.1 Media // Publishers and printers",
        "4":"17.2 Media // Television / Film / Video",
        "2":"17.3 Media // Radio",
        "3":"17.4 Media // Internet Services",
        "5":"17.5 Media // Other",
     }
  },
  "10":{
     "NOMBRE":"18.0 Mining and quarries",
     "SUBSECTORES":{
        "1":"18.1 Mines and Quarries // Other / Does not apply"
     }
  },
  "11":{
     "NOMBRE":"(OLD) Non-profit and charitable organizations",
     "SUBSECTORES":{
        "1":"-"
     }
  },
  "12":{
     "NOMBRE":"21.0 Retail Trade",
     "SUBSECTORES":{
        "4":"21.1 Retail Trade // Clothing / Textiles / Footwear",
        "2":"21.2 Retail Trade // Computers / Electronics",
        "1":"21.3 Retail Trade // Food / Warehouse",
        "5":"21.4 Retail Trade // Electronic Commerce",
        "3":"21.5 Retail Trade // Specialty Products",
        "6":"21.6 Retail Trade // Other",
     }
  },
  "13":{
     "NOMBRE":"11.0 Financial Services and Insurance",
     "SUBSECTORES":{
        "1":"11.1 Financial Services and Insurance // Investments",
        "9":"11.2 Financial Services and Insurance // Accounting",
        "8":"11.3 Financial and Insurance Services // Banking / Credit Services",
        "5":"11.4 Financial Services and Insurance // Health Insurance",
        "7":"11.5 Financial Services and Insurance // Insurance in General",
        "6":"11.6 Financial Services and Insurance // Life Insurance",
        "3":"11.7 Financial Services and Insurance // Automobile Insurance",
        "4":"11.8 Financial Services and Insurance // Home Insurance",
        "2":"11.9 Financial Services and Insurance // Reinsurance",
        "10":"11.10 Financial Services and Insurance // Other",
     }
  },
  "14":{
    "NOMBRE":"14.0 Industrial Services",
    "SUBSECTORES":{
      "3":"14.1 Industrial Services // Vehicle Repair and Maintenance",
      "2":"14.2 Industrial Services // Industrial Design",
      "1":"14.3 Industrial Services // Waste / Garbage / Recycling Management",
      "4":"14.4 Industrial Services // Other",
    }
  },
  "15":{
     "NOMBRE":"19.0 Professional Services",
     "SUBSECTORES":{
        "14":"19.1 Professional Services // Advertising and Marketing",
        "2":"19.2 Professional Services // Architecture / Design",
        "5":"19.3 Professional Services // Consulting - Administration",
        "7":"19.4 Professional Services // Engineering Consulting",
        "4":"19.5 Professional Services // Environmental Consulting",
        "8":"19.6 Professional Services // Manufacturing Consulting",
        "3":"19.7 Professional Services // Risk Assessment / Actuarial Consulting",
        "11":"19.8 Professional Services // Legal Advice",
        "16":"19.9 Professional Services // Security",
        "15":"19.10 Professional Services // Personnel Hiring",
        "6":"19.11 Professional Services // Telephone Support / Sales Centers",
        "1":"19.12 Professional Services // Travel Administration",
        "19":"19.13 Professional Services // Other",
        "12":"(OLD) Professional services // Business process outsourcing",
        "13":"(OLD) Professional services // Business process outsourcing / Call centers",
        "9":"(OLD) Professional Services // Accounting, Bookkeeping and Auditing",
        "17":"(OLD) Professional services // Advertising and marketing / Advertising",
        "18":"(OLD) Professional Services // Advertising and Marketing / Direct Marketing",
        "10":"(OLD) Professional services // Education and training"
     }
  },
  "16":{
     "NOMBRE":"22.0 Social Services and Government Agencies",
     "SUBSECTORES":{
        "3":"22.1 Social Services and Government Agencies // Business Services",
        "1":"22.2 Social Services and Government Agencies // Culture and Art",
        "2":"22.3 Social Services and Government Agencies // Education",
        "6":"22.4 Social Services and Government Agencies… General public administration activities",
        "5":"22.5 Social Services and Government Agencies // Housing",
        "4":"22.6 Social Services and Government Agencies // Human Health and Social Work",
        "7":"22.7 Social Services and Government Agencies // Residential Care",
        "8":"22.8 Social Services and Government Agencies // Other",
     }
  },
  "17":{
     "NOMBRE":"15.0 Information Technologies",
     "SUBSECTORES":{
        "3":"15.1 Information Technology // Hardware",
        "4":"15.2 Information Technology // Internet Service Provider",
        "5":"15.3 Information Technology // Software",
        "6":"15.4 Information Technologies // Internet Services",
        "1":"15.5 Information Technology // IT Consulting",
        "2":"15.6 Information Technology // Data Storage / Management",
        "7":"15.7 Information Technology // Other",
     }
  },
  "18":{
     "NOMBRE":"24.0 Transportation",
     "SUBSECTORES":{
        "2":"24.1 Transportation // Airline / Commercial Aviation",
        "1":"24.2 Transport // Parcel transport",
        "3":"24.3 Transport // Land and sea transport of passengers",
        "4":"24.4 Transportation // Transportation and Storage",
        "5":"24.5 Transport // Other",
     }
  },
  "19":{
     "NOMBRE":"23.0 Telecommunications",
     "SUBSECTORES":{
        "1":"23.1 Telecommunications // Other / Does not apply"
     }
  },
  "20":{
     "NOMBRE":"8.0 Electronics",
     "SUBSECTORES":{
        "1":"8.1 Electronics // Other / Does not apply"
     }
  },
  "21":{
     "NOMBRE":"9.0 Engineering",
     "SUBSECTORES":{
        "1":"9.1 Engineering // Other / Does not apply"
     }
  },
  "22":{
     "NOMBRE":"10.0 Entertainment",
     "SUBSECTORES":{
        "3":"10.1 Entertainment // Performing arts and spectator sports",
        "2":"10.2 Entertainment // Museums",
        "1":"10.3 Entertainment // Fun and games of chance",
        "4":"10.4 Entertainment // Other",
     }
  },
  "23":{
     "NOMBRE":"20.0 Real Estate",
     "SUBSECTORES":{
        "1":"20.1 Real Estate // Housing",
        "2":"20.2 Real Estate // Property management",
        "3":"20.3 Real Estate // Other",
     }
  },
  "24":{
     "NOMBRE":"25.0 Other",
     "SUBSECTORES":{
        "1":"25.1 Other / Does not apply"
     }
  },
  "25": {
    "NOMBRE":"3.0 Services for the Elderly",
    "SUBSECTORES": {
      "1":"3.1 Services for the Elderly // Housing and care for the Elderly",
      "2":"3.2 Services for the Elderly // Home care",
      "3":"3.3 Services for the Elderly // Other",
    }
  }
}

export const ranking = {
  '1': {
    'NOMBRE': 'Yes',
    'TIPO': {
      '1': 'Less than 50',
      '2': '50 to 500 No Multinationals',
      '3': '50 to 500 Multinationals',
      '4': 'Large (500 to 4999)',
      '5': '5000 or more'
      // '6': 'Public Sector',
      // '7': 'Does not participate in the Ranking'
    }
  },
  '2': {
    'NOMBRE': 'No',
    'TIPO': {
      '1': 'Less than 50',
      '2': '50 to 500 No Multinationals',
      '3': '50 to 500 Multinationals',
      '4': 'Large (500 to 4999)',
      '5': '5000 or more'
    }
  },
  'Nacional': 'National',
  'Multinacional': 'Multinational'
}

export const productos = {
  '1': 'Certify',
  '2': 'Measurement',
  '3': 'NOM-035',
  '4': 'Pulse Check',
  '5': 'Documentator NOM-035',
  '6': 'Focus Area',
  '7': 'File manager',
  '8': 'Culture Audit',
  '9': 'Culture Audit 5.0',
  '10': 'Culture Audit Training',
  '11': 'Measurement enhanced',
  '12': 'Measurement + MST',
  '13': 'Measurement by areas',
  '14': 'Measurement by leaders',
  '15': 'Measurement by dimensions',
  '16': 'Measurement to certify',
  '17': 'Results',
  '18': '4All',
  '19': 'NOM-035 Better',
  '20': 'Certify v2.0',
  '21': 'Global results',
  '22': '4ALL practices single results',
  '23': 'Complete results',
  '24': 'SILVER package',
  '25': 'GOLD package',
  '26': 'PLATINUM package',
  '27': 'Izzi',
  '30': 'Culture Audit Costa Rica',
  '31': 'Culture Audit GoFlow',
  '32': 'Culture Audit 5.0 Panamá',
  '33': 'Culture Audit 5.0 Strategic Partners',
  '34': 'Results 5.0 Versión 3.1',
  '35': 'Results 5.0 Versión 3.2',
  '36': 'Results 5.0 Versión 3.3',
  '37':'Culture Audit SP',
  '38':'Action Plan',
  '39':'NOM-035 Silver',
  '40': 'Certify v3.0',
  '41': 'Measurement v3.0',
  '42': 'Pulse Check v3.0',
  '43': 'Focus Area v3.0',
  '44': 'Culture Audit 2021 México',
  '45': 'Culture Audit 2021 Costa Rica',
  '46': 'Culture Audit 2021 Panamá',
  '48': 'SP 2021',
  '49': 'Culture Audit GoFlow 2-2021',
  '50': 'Culture Audit 5.0',
  '51': 'Culture Audit 4All',
  '52': 'Cultural Go Express',
  'CULTUREGOEXPRESS':'Cultural Go Express',
  '53':'Leader GO',
  '54':'Action GO',
  '55': 'Internal Communication Culture Audit (ICCA)',
  'ICI': 'ICI',
  '56': 'AMCO',
  '57': 'Decent Work',
  '58':'First Job',
  '59':'Internal Communication Culture Audit (ICCA)',
  'ENCUESTA':'Additional certifications',
  '60':'Certify (import emprising)',
  '61':'Culture Brief',
  '62':'Culture Brief + Culture Audit',
  '63':'NOM-035 v3.0',
  '64':'SP 2022',
  '65':'Culture Audit GoFlow 2 2022',
  '66':'Culture Audit Standard 1',
  '67':'Culture Audit® CA&C',
  '69': 'Certify silver',
  '70':'GoFlow results',
  '71':'Culture audit (certify) 2022',
  '72':'Cultural audit (certify, rkg.) 2022',
  '73':'Cultural audit (certify, rkg.) 2022',
  '68':'Swift',
  '75':'GPTW + GCTI',
  '76':'Culture Audit (certify,rkg. y adic.) 2024',
  '77':'Culture Brief (certify) 2024',
  '78':'Culture Audit (certify and ranking) 2024',
  '80':'Culture Audit'
}

export const productosTurquia = {
  '1': 'Certify',
  '2': 'Measurement',
  '3': 'NOM-035',
  '4': 'Pulse Check',
  '5': 'Documentator NOM-035',
  '6': 'Focus Area',
  '7': 'File manager',
  '8': 'Culture Audit',
  '9': 'Culture Brief ve Culture Audit 5.0',
  '10': 'Culture Audit training',
  '11': 'Measurement enhanced',
  '12': 'Measurement + MST',
  '13': 'Measurement by areas',
  '14': 'Measurement by leaders',
  '15': 'Measurement by dimensions',
  '16': 'Measurement to certify',
  '17': 'Results',
  '18': '4All',
  '19': 'NOM-035 Better',
  '20': 'Certify v2.0',
  '21': 'Global results',
  '22': '4ALL practices single results',
  '23': 'Complete results',
  '24': 'SILVER package',
  '25': 'GOLD package',
  '26': 'PLATINUM package',
  '27': 'Izzi',
  '28': 'Culture Brief 5.0',
  '29': 'Culture Audit 5.0',
  '30': 'Culture Audit Costa Rica',
  '31': 'Culture Audit GoFlow',
  '32': 'Culture Audit 5.0 Panamá',
  '33': 'Culture Audit 5.0 Strategic Partners',
  '34': 'Results 5.0 Versión 3.1',
  '35': 'Results 5.0 Versión 3.2',
  '36': 'Results 5.0 Versión 3.3',
  '40': 'Certify v3.0',
  '41': 'Measurement v3.0',
  '42': 'Pulse Check v3.0',
  '43': 'Focus Area v3.0',
  '60':'Certify (import emprising)',
  '54':'Action GO',
  '74':'Özel Liste',
}

export const categorias = {
  'Certify': 'Certify products',
  'Measure': 'Measurement products',
  'Norm 35': 'NOM-035 products',
  'Pulse Check': 'Pulse Check products',
  'Focus Area': 'Focus Area products',
  'Drive': 'File manager',
  'Culture Audit': 'Culture Audit products',
  'Resultados': 'Results\' products',
  'Resultados 4 ALL': '4All products',
  'Resultados 5.0': 'Results 5.0 products',
  'Culture Audit Action Plan':'Action plan',
  'Leader GO':'Leader GO',
  'Action GO':'Action GO',
  'Certify Amco':'Additional certifications',
  'Culture Audit ICCA':'ICCA products',
  'AMCO': {
    'Measure': 'ICI products',
    'Culture Audit': 'ICCA products',
  },
  'Resultados V2 HK':'Certify (import emprising)',
  'Swift':'Swift',
}

export const niveles = {
  '1': 'Company',
  '2': 'Administrator',
  '3': 'ITBM',
  '4': 'Results',
  '5': 'Segmented Results',
  '8': 'Culture Audit product',
  '9':'Results 5.0',
  '10':'Company HR',
  '11': 'Izzi',
  '12': 'ActionGo',
  '13': 'Segmented Results & ActionGo',
  '14': 'ActionGo Leader',
  '15': 'User ActionGo Leader',
  '17': 'Swift Wholesaler',
  '18': 'Web company profile',
  '19': 'Results 2.0',
}

export const regiones = {
  '1': 'Caribbean',
  '2': 'Central America',
  '3': 'Central America and Caribbean',
  '4': 'Region Bajio',
  '5': 'Central Region',
  '6': 'West Central Region',
  '7': 'South Central Region',
  '8': 'Northeast Region',
  '9': 'Northwest Region',
  '10': 'Southeast Region',
  '11': 'Hong Kong',
  '12': 'Taiwan',
  '13': 'Mainland China',
  '14': 'Greater China',
  '15': 'Turkey',
}

export const plantillas = {
  '5d826095d06d596a84de6315': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR'
  },

  '5dcb61e940fb582bc44adf49': {
    'NOMBRE':'TR_ESTANDAR'
  },

  '5dcc946633e1ff000870107e': {
    'NOMBRE':'04_ENGLISH_JAPAN'
  },

  '5dcdd9fd33e1ff1aacf6f04f': {
    'NOMBRE':'01_NORM035_ES_EN_-50'
  },

  '5ddc3fa4f323d727d09870ad': {
    'NOMBRE':'ING_SIMP_TRAD_ESTANDAR'
  },

  '5de58de640fb582e0c18d730': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR'
  },

  '5de69aa4a943da3efc4d0fa6': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_PULSECHECK'
  },

  '5de9498fa943da3efc4d0fa8': {
    'NOMBRE':'05_ING_ESTANDAR'
  },

  '5df820df65e4986b14d1f71c': {
    'NOMBRE':'01_NORM035_ES_EN_+50'
  },

  '5dfc26cec8800d5188a18875': {
    'NOMBRE':'CAYC_ESTANDAR_ES_Y_EN'
  },

  '5e166105d06d595eb04dca00': {
    'NOMBRE':'Focus_Estandar'
  },

  '5e1754a5f323d72aac6d8726': {
    'NOMBRE':'TR TI + EVP + GPTW LEADER'
  },

  '5e17930b65e4983a3016a4ed': {
    'NOMBRE':'TR TI + EVP'
  },

  '5e2100c6f323d721045812c5': {
    'NOMBRE':'CAYC_ESTANDAR CAYC 2020'
  },

  '5e21042ff323d721045812c6': {
    'NOMBRE':'04_DIVERSIDAD_E_INCLUSIÓN'
  },

  '5e210575f323d721045812c7': {
    'NOMBRE':'04_ESP_GOBIERNO'
  },

  '5e2b6dbdc8800d52f45fc248': {
    'NOMBRE':'TEMPLATE 10 PREGUNTAS ESP'
  },

  '5e2f72c8c8800d3398c463a4': {
    'NOMBRE':'CAYC_GOBIERNO'
  },

  '5e3c59b5b473cb6d3e40f902': {
    'NOMBRE':'ING_RUMANO_ESTANDAR'
  },

  '5e697232b473cb6d3e84d87d': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR'
  },

  '5ec8450db473cb6d3ec9d153': {
    'NOMBRE':'04_ESP_ING_ESTANDAR_US_MEDIR1'
  },

  '5ec84527b473cb6d3ec9dcdb': {
    'NOMBRE':'04_ESP_ING_ESTANDAR_MX_MEDIR1'
  },

  '5e6972f3b473cb6d3e84e1e0': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR1'
  },

  '5e697302b473cb6d3e84e2a3': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR2'
  },

  '5e697311b473cb6d3e84e364': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR3'
  },

  '5e697329b473cb6d3e84e490': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR4'
  },

  '5f074b90b473cb6d3eb363d1': {
    'NOMBRE':'ESP_MEDIR_CREDIBILIDAD'
  },

  '5e69734fb473cb6d3e84e656': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR5'
  },

  '5e697367b473cb6d3e84e791': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR6'
  },

  '5e738efbb473cb6d3e8c3915': {
    'NOMBRE':'ESP_CAYC_Diversidad'
  },

  '5e86487eb473cb6d3e09cc42': {
    'NOMBRE':'01_NORM035_ES_EN_-50'
  },

  '5e864896b473cb6d3e09cde1': {
    'NOMBRE':'01_NORM035_ES_EN_+50'
  },
  '5ebb34dab473cb6d3edd2d32': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_US'
  },

  '5ebc06d1b473cb6d3ef68147': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MX'
  },

  '5f2d7cdfb473cb6d3edd2c48': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_PT'
  },

  //PLANTILLAS DE CERTIFICAR 2.0
    '5e960018b473cb6d3ec5f935': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR'
    },

    '5e96007cb473cb6d3ec60098': {
      'NOMBRE':'TR_ESTANDAR'
    },

    '5e9600a6b473cb6d3ec603c7': {
      'NOMBRE':'04_ENGLISH_JAPAN'
    },

    '5e9600f0b473cb6d3ec6095a': {
      'NOMBRE':'ING_SIMP_TRAD_ESTANDAR'
    },

    '5e960116b473cb6d3ec60c2f': {
      'NOMBRE':'05_ING_ESTANDAR'
    },

    '5e96039fb473cb6d3ec64310': {
      'NOMBRE':'CAYC_ESTANDAR_ES_Y_EN'
    },

    '5e9603d7b473cb6d3ec6485e': {
      'NOMBRE':'TR TI + EVP + GPTW LEADER'
    },

    '5e9604f7b473cb6d3ec66540': {
      'NOMBRE':'TR TI + EVP'
    },

    '5e960525b473cb6d3ec66a3f': {
      'NOMBRE':'CAYC_ESTANDAR CAYC 2020'
    },

    '5e960549b473cb6d3ec66e30': {
      'NOMBRE':'04_DIVERSIDAD_E_INCLUSIÓN'
    },

    '5e96056ab473cb6d3ec671f1': {
      'NOMBRE':'04_ESP_GOBIERNO'
    },

    '5e9605b5b473cb6d3ec67a55': {
      'NOMBRE':'CAYC_GOBIERNO'
    },

    '5e9605e0b473cb6d3ec67f3c': {
      'NOMBRE':'ING_RUMANO_ESTANDAR'
    },

    '5e96060fb473cb6d3ec684d8': {
      'NOMBRE':'ESP_CAYC_Diversidad'
    },
    '5edff2d2b473cb6d3e3dcc07': {
      'NOMBRE': 'IZZI_ESTANDAR_ES_Y_EN'
    },

    '5f109a39b473cb6d3ea95e69': {
      'NOMBRE':'ING_VI_ESTANDAR'
    },

    '5f0f390cb473cb6d3ea20f9c': {
      'NOMBRE':'CAYC_ESTANDAR_ES_Y_EN_V2'
    },

    '5ec6b0a6b473cb6d3e9275ff': {
      'NOMBRE':'04_EN_TR_ESTANDAR_PULSECHECK'
    },

    '5f2adf75b473cb6d3eb782e2': {
      'NOMBRE':'REACTIVOS-BRASIL-PT'
    },

    '5f0773b196bd3c7a9e469a8b': {
      'NOMBRE':'TR_ESTANDAR_+COVID'
    },

    '5f0773ea96bd3c7a9e469e56': {
      'NOMBRE':'TR TI + EVP + GPTW LEADER_+COVID'
    },

    '5f07740e96bd3c7a9e46a0f1': {
      'NOMBRE':'TR TI + EVP_+COVID'
    },

    '5f40081eb473cb6d3ec99926': {
      'NOMBRE':'TR TI + EVP + GPTW LEADER TR'
    },

    '5f230cdab473cb6d3e89bd9a': {
      'NOMBRE':'Broker 14-ESTANDAR-ESPAÑOL'
    },
    '5f5fbb3496bd3c7a9eac2768': {
      'NOMBRE':'04_ESP_ING_ESTANDAR_US'
    },

    '5f5fb74496bd3c7a9eab015a': {
      'NOMBRE':'04_ESP_ING_ESTANDAR_MX'
    },

    '5f68c206b473cb6d3ebe8473': {
      'NOMBRE':'04_ESP_ING_ESTANDAR_US'
    },

    '5f68c222b473cb6d3ebe94b3': {
      'NOMBRE':'04_ESP_ING_ESTANDAR_MX'
    },
    '5f84a2fab473cb6d3e017c0d': {
      'NOMBRE':'ESP_ESTANDAR_IDIOMAS'
    },
    '5f733fcab473cb6d3e19d56c': {
      'NOMBRE':'04_ESP_Gobierno_MX'
    },
    // pendiente TK
    '5e14fc2cf323d72aac6d8722': {
      'NOMBRE':' '
    },
    // pendiente TK
    '5e14fcc4f323d72aac6d8723': {
      'NOMBRE':' '
    },
    // pendiente MX
    '5d71b21db11f333a30de813e': {
      'NOMBRE':' '
    },

    '5f99fa14b473cb6d3e2d4012': {
      'NOMBRE':'TR_EN_DE_PT_ZH1_TI_+_EVP'
    },

    '5f9b4550b473cb6d3e51c24d': {
      'NOMBRE':'01_NORM035_ES_EN_-50'
    },

    '5fac18aeb473cb6d3e0d3d91': {
      'NOMBRE': '04_ESP_ING_ESTANDAR_MX'
    },
    '5fac1b3eb473cb6d3e0d6cff': {
      'NOMBRE': '04_ESP_ING_ESTANDAR_US'
    },
    '5fcebf59c1057065a70fe712':{
      'NOMBRE':'TR_ESTANDAR_+COVID v2'
    },
    '6046a10e7308ab51607f95b5':{
      'NOMBRE':''
    }
}

export const paises = {
  '1': 'Mexico',
  '2': 'Costa Rica',
  '3': 'Panama'
}

export const answer = {
  '1': 'Cultural Go Survey',
  '2': 'Kiosk',
  '3': 'No answer / Foreign leader',
  '4': 'Paper',
  '5': 'Does not apply',
}
export const nameTHConsEncuesta = {
  'TH_SUR_TOK':'Survey Token',
  'TH_NAM_EMP': 'Company Name',
  'TH_NAM_EMP_PUB': 'Publication Name',
  'TH_PA_EMP': 'Country',
  'TH_CER_DAT': 'Certificate date',
  'TH_SEC': 'Sector',
  'TH_TI_ENC': 'Type of survey',
  'TH_SUR_STA': 'Survey start',
  'TH_SUR_EN': 'End survey',
  'TH_ID_ACON': 'ID Acount',
  'TH_ID_OPOR': 'ID Opportunity',
  'TH_ANO_RA': 'Ranking Year',
  'TH_COMPA': 'Fellowship',
  'TH_CRED':'Credibility',
  'TH_CATE_TAN':'Ranking Category',
  'TH_CONFI':'Trust',
  'TH_ES_MULT':'Is Multinational?',
  'TH_GR_MUL_PER':'Multinational Group to which you belong',
  'TH_GEST':'Gestalt',
  'TH_IMPA':'Impartiality',
  'TH_INN_TOD':'Innovation for All',
  'TH_LID_EFE':'Effective Leadership',
  'TH_LID_MOV':'Leadership in Motion' ,
  'TH_MAX_CAS':'Maximize CAST(Human Potential)',
  'TH_ORG':'Pride',
  'TH_PA_LEAFF':'Country',
  'TH_PR_ARE':'Average area',
  'TH_PR_EMP':'Average company',
  'TH_PR_TI':' IT average',
  'TH_REG':'Region',
  'TH_RES':'Respect',
  'TH_PRO_CUE':'Account owner',
  'TH_TOT_CA_AVG':'Total CA (AVG)',
  'TH_TOT_CA_SU':'Total CA (SUMA)',
  'TH_VAL':'Values',
  'TH_EN_ULT_12':'In the last 12 months, how many opportunities have you had to develop, innovate or create new or better ways of:',
  'TH_NIV_CONF':'What is your level of confidence in the capabilities of your companys managers? I APPLY (YES / NO):',
  'TH_#_RES_EST':'# ANSWERS STUDIES',
  'TH_CAR_HOMO':'Position or function approved US I APPLY (YES / NO):',
  'TH_ED_US_AP':'Age US APPLICABLE',
  'TH_GEN_US_AP':'Generation US APLICO (YES / NO):',
  'TH_GE_APL':'Gender APPLICABLE (YES / NO):',
  'TH_SI_AP':'Employment status US APPLICABLE (YES / NO):',
  'TH_HC':'# HC',

}
